import { Injectable, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as auth0 from 'auth0-js';
import { JwtHelperService } from '@auth0/angular-jwt';
(window as any).global = window;
import { AppConfig } from '../_helpers/appconfig.service';
import { HttpClient } from '@angular/common/http';
import { IAccess } from '../_models/access.interface';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ParameterData } from '../_helpers/parameter.data';
import { DataService } from '../_helpers/dataservice.service'
import { CustomerService } from '../_services/customer.service';
import { UserService } from '../_services/user.service';
import * as moment from 'moment';
import { CommonDataService } from '../_services/common-data.service';
import { CustomDesignOptions } from '../sharedcomp/constans/customDesign.constans';
import { ConfigurationService } from './configuration.service';
import { Configuration, SubMenuProperties, Menu, MenuProperties, MenuItemRender, SubMenuItemRender } from '../_models';
import { CustomerType } from '../_enums';
import { CompanyMenu, CorporateMenu } from '../sharedcomp/constans/menus.constants';
import { ApplicationService } from './application.service';
import { ApplicationTypes } from '../sharedcomp/constans/application-type.constans';
import { DesignVersionEnum } from '../_enums/design-version.enum';

@Injectable()
export class AuthService {

  auth0 = new auth0.WebAuth({
    clientID: AppConfig.settings.auth0config.clientID,
    domain: AppConfig.settings.auth0config.domain,
    responseType: 'token id_token',
    redirectUri: AppConfig.settings.apiServer.baseURL + '' + AppConfig.settings.auth0config.callbackURL,
    scope: 'openid profile',
    leeway: 60
  });

  application: any;
  version: any;
  userProfile: any;
  dataAccessList: IAccess;
  fdataAccessList: any;
  fdataCorpAccessList: any;
  fdataUserAccessList: any;

  customerStatus: string;
  customerType: string;
  buildMenuarray: string;
  companyType: any;
  grants: any;
  tempAccessModules: any[] = [];
  accessModules: any[] = [];
  tempGrants: any;
  tempMainMenu: any;
  tempSubMenu: any;
  companyAccessStatus: any;
  userProfileStatus: any;
  isNewArrival: string;
  companyId: any;
  baseURL: string;

  //Event Emitter for header User Name Change
  @Output() getLoggedInStatus: EventEmitter<any> = new EventEmitter();
  @Output() getReloadedInStatus: EventEmitter<any> = new EventEmitter();

  constructor(
    public router: Router
    , private http: HttpClient
    , private parameterData: ParameterData
    , private sanitizer: DomSanitizer
    , private dataService: DataService
    , private customerService: CustomerService
    , private userService: UserService
    , private commonDataService: CommonDataService
    , private configurationService: ConfigurationService
    , private _applicationService: ApplicationService
  ) {
    this.application = AppConfig.settings.applicationSetting.application;
    this.version = AppConfig.settings.applicationSetting.version;
    this.baseURL = AppConfig.settings.apiServer.baseURL;
  }


  public login(): void {
    this.isNewArrival = localStorage.getItem('isNew');
    if (this.isNewArrival === undefined || this.isNewArrival === null) {
      localStorage.clear();
    } else if (Number(this.isNewArrival) >= 1) {
      localStorage.clear();
      localStorage.setItem('isNew', this.isNewArrival);
    }
    sessionStorage.removeItem('accountid');
    sessionStorage.removeItem('graphData');

    this.auth0.logout({
      returnTo: AppConfig.settings.apiServer.baseURL + '' + AppConfig.settings.auth0config.logoutUrl,
      clientID: AppConfig.settings.auth0config.clientID
    });

    this.auth0.authorize({
      prompt: 'login'
    });
  }

  public handleAuthentication(): void {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
      } else if (err) {
        this.router.navigate(['/logout']);
        alert(`Error: ${err.error}. Check the console for further details.`);
        alert("Por favor, borre la memoria caché de su navegador y luego intente iniciar sesión.");
      }
      else if((authResult == null || authResult == undefined)&& (localStorage.getItem('isKashioLoggedIn') == null || localStorage.getItem('isKashioLoggedIn') == undefined)){
        this.login();
      }
      else if((authResult == null || authResult == undefined) && (localStorage.getItem('isKashioLoggedIn') === 'true')){
        if(localStorage.getItem("id_token") != null || localStorage.getItem("id_token") != undefined){
          const helper = new JwtHelperService();
          const isExpired = helper.isTokenExpired(localStorage.getItem("id_token"));
          if(isExpired == true){
            this.login();
          }else{
            //AVOID MULTILOGIN - https://trello.com/c/Cq3C5yWy/708-avoid-multilogin-kcms - Start
            sessionStorage.setItem('isAnyLoginSession','Yes');
            sessionStorage.setItem('userEmail', localStorage.getItem('userEmail'));
            //AVOID MULTILOGIN - End
            this.checkCompanyAndUserStatus();
          }
        } else {
          this.login()
        }
      }
    });
  }

  kashioLogout(){
    sessionStorage.removeItem('isAnyLoginSession');
    sessionStorage.removeItem('userEmail');
    this.getLoggedInStatus.emit('false');
    this.getReloadedInStatus.emit('true');
    this.auth0.logout({

      returnTo: AppConfig.settings.apiServer.baseURL,
      clientID: AppConfig.settings.auth0config.clientID

    });
    this.auth0.authorize({
      prompt: 'login'
    });
  }

  setValuesInLocalStorage(value) {
    localStorage.setItem('companyId', value.companyId);
    localStorage.setItem('userId', value.userId);
    localStorage.setItem('userEmail', value.userEmail);
    localStorage.setItem('username', value.username);
    localStorage.setItem('isadmin', value.isadmin);
    sessionStorage.setItem('userEmail', value.userEmail);
  }

  private setSession(authResult): void {
    const helper = new JwtHelperService();
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('isKashioLoggedIn', 'true');
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);

    let returntoken = helper.decodeToken(authResult.idToken);
    if (returntoken["https://www.kashio.net/timezone"] === undefined || returntoken["https://www.kashio.net/timezone"] === '') {
      localStorage.setItem('Oldtimezone', '-5.00');
    } else {
      localStorage.setItem('Oldtimezone', returntoken["https://www.kashio.net/timezone"]);
    }

    localStorage.setItem('userPhoto', returntoken["picture"]);
    localStorage.setItem('subcompanyId', 'undefined');
    localStorage.setItem('isCorporate', 'undefined');
    this.getLoggedInStatus.emit('true');

    const values = {
      'companyId': returntoken["https://www.kashio.net/kcore_company_id"],
      'userId': returntoken["https://www.kashio.net/kcore_user_id"],
      'userEmail': returntoken["https://www.kashio.net/kcore_email"],
      'username': returntoken["https://www.kashio.net/kcore_name"],
      'isadmin': returntoken["https://www.kashio.net/kcore_is_admin"]
    };

    const SSO = returntoken["https://www.kashio.net/SSO"];
    if (SSO) {
      const configurationURL = SSO.find(t => t.baseUrl === this.baseURL);
      if (configurationURL) {
        this.checkCompanyAndUserStatus(true, configurationURL.user_id);
      } else {
        this.logout();
      }
    } else {
      this.setValuesInLocalStorage(values);
      this.checkCompanyAndUserStatus();
    }
    sessionStorage.setItem('isAnyLoginSession', 'Yes');
  }

  checkCompanyAndUserStatus(dataFinded = false, userIdF = "") {
    const userId = dataFinded ? userIdF : localStorage.getItem('userId');
    let userStatus = this.userService.getUser(userId);
    userStatus
      .pipe(
        switchMap(userResponse => {
          this.userProfileStatus = userResponse;
          if (dataFinded) {
            const values = {
              'companyId': userResponse.customer.public_id,
              'userId': userResponse.public_id,
              'userEmail': userResponse.email,
              'username': userResponse.name,
              'isadmin': userResponse.role === 'ADMIN'
            };
            this.setValuesInLocalStorage(values);
          }
          const customerId = dataFinded ? userResponse.customer.public_id : localStorage.getItem('companyId');
          let companyAccessStatus = this.customerService.getCustomerCompanyDetailsList(customerId);
          companyAccessStatus.subscribe(data => {
            localStorage.setItem('country', data.body.address.country);
            localStorage.setItem('timezone', data.body.timezone);
            localStorage.setItem('document_type', data.body.document_type);
            localStorage.setItem('document_id', data.body.document_id);
          })
          return companyAccessStatus.pipe(
            catchError(error =>  of('Failed while trying to check company and user status.'))
          );
        })
      ).subscribe({
        next: response => {
          if (response !== 'Failed while trying to check company and user status.') {
            if (response.body.status === 'ACTIVE' && this.userProfileStatus.status === 'ACTIVE') {
              this.CheckCompanyAccessStatus(response);
              this.getCommonData();
            } else {
              alert("El estado del usuario es INACTIVO.");
              this.logout();
            }
          } else {
            console.error('Failed while trying to check company and user status. ');
            this.logout();
          }
        },
        error: error => {
          console.error('Failed while trying to check company and user status. ' + error);
          this.logout();
        }
      });
  }

  getCommonData() {
    setTimeout(() => {
      if (localStorage.getItem('subcompanyId') == 'undefined') {
        this.companyId = localStorage.getItem('companyId');
      } else {
        this.companyId = localStorage.getItem('subcompanyId');
      }
      this.commonDataService.getCommonData(this.companyId);
    }, 1000)
  }

  getCustomerId() {
    let customerId;
    if ((localStorage.getItem('companyId') != null || localStorage.getItem('companyId') !== '') && (localStorage.getItem('application') != null || localStorage.getItem('application') !== '')) {
      if (localStorage.getItem('isCorporate') === 'Yes') {
        customerId = localStorage.getItem('subcompanyId');
      } else {
        customerId = localStorage.getItem('companyId');
      }
    }
    return customerId;
  }

  getDesignVersion(data: Configuration, app: string): 'V1' | 'V2' {
    return DesignVersionEnum.designVersionDefault;
  }

  getModulesFromAccessJSON(app: string, executeGrants = false, type = "") {
    this._applicationService.setApplicationType(app);
    const customerId = this.getCustomerId();
    this.getAllAccessDetails()
      .pipe(
        switchMap(data => {
          this.tempAccessModules = data["data"];
          this.tempAccessModules = this.tempAccessModules.filter(t => t.application === app);
          if (this.tempAccessModules.length > 0) {
            this.accessModules = this.tempAccessModules[0].modules[0];
          }

          const urlConfig: (typeof CustomDesignOptions)[keyof typeof CustomDesignOptions] = CustomDesignOptions.CUSTOMER;
          let designConfiguration = this.configurationService.getCustomDesignConfiguration(customerId, urlConfig);
          return designConfiguration.pipe(
            map(data => this.getDesignVersion(data, app)),
            catchError(error => of('V2'))
          )
        })
      ).subscribe({
        next: response => {
          if (executeGrants) {
            this.getKashioGrants(app, response as 'V1' | 'V2', type);
          }
        },
        error: error => {
          console.error('Failed while trying to get access from JSON. ' + error);
        }
      });
  }

  /* Get Company Access Status */
  CheckCompanyAccessStatus(d) {
    if (d.status == "404" || d.status == "500") {
      this.logout();
    } else {
      let results = d.body.status;
      this.customerStatus = results;
      this.customerType = d.body.type;
      if (this.customerStatus == 'INACTIVE') {
        this.logout();
      }
      if (this.customerType === CustomerType.CORPORATE) {
        localStorage.setItem('isCorporate', 'Yes');
        localStorage.setItem('customername', d.body.name);
        localStorage.setItem('subcompanyId', d.body.public_id);
        localStorage.setItem('application', 'CORPORATE');
        this.getModulesFromAccessJSON('CORPORATE', true);
      }
      if (this.customerType === CustomerType.COMPANY) {
        localStorage.setItem('application', 'PAYMENTS');
        this.getModulesFromAccessJSON('PAYMENTS', true);
      }
      if (this.customerType === CustomerType.COMPANY_COLLECT) {
        localStorage.setItem('application', 'COLLECT');
        this.getModulesFromAccessJSON('COLLECT', true);
      }
      if (this.customerType === CustomerType.COMPANY_PAYOUT) {
        localStorage.setItem('application', 'PAYOUTS');
        this.getModulesFromAccessJSON('PAYOUTS', true);
      }
      if (this.customerType === CustomerType.PSP_PAYOUT) {
        localStorage.setItem('application', 'PAYOUTS');
        localStorage.setItem('customerType', CustomerType.PSP_PAYOUT);
        this.getModulesFromAccessJSON('PAYOUTS', true);
      }
    }
  }

  public logout(): void {
    this.getLoggedInStatus.emit('false');
    this.getReloadedInStatus.emit('true');
    this.auth0.logout({
      returnTo: AppConfig.settings.apiServer.baseURL + '' + AppConfig.settings.auth0config.logoutUrl,
      clientID: AppConfig.settings.auth0config.clientID
    });
    this.router.navigate(['/logout']);
  }

  public isAuthenticated(): boolean {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at') || '{}');
    return new Date().getTime() < expiresAt;
  }

  async isKashioGrantsAvailable() {
    if (this.grants == undefined) {
      try {
        const data = await this.userService.getAsyncGrants(localStorage.getItem('application'), localStorage.getItem('userId'));
        this.tempGrants = data;
        this.grants = this.tempGrants.grants
      }
      catch (error) {
        console.error('Failed while trying to get the Grants.' + error)
      }
    }
  }

  checkGrants(menu, subMenu) {
    if (this.grants != undefined && (this.grants[menu] != null || this.grants[menu] != undefined)) {
      let menuList = this.grants[menu];
      var strArray = menuList;
      if (strArray.includes(subMenu)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  buildMenuFromDesign(designVersion: 'V1' | 'V2', app: string, type: (typeof CustomerType)[keyof typeof CustomerType]) {
    if (designVersion === 'V1') {
      this.dataService.designVersion(designVersion);
      if (type === CustomerType.CORPORATE) {
        this.buildKashioCorporateMenu();
      } else if (type === CustomerType.COMPANY || type === CustomerType.COMPANY_COLLECT || type === CustomerType.COMPANY_PAYOUT || type === CustomerType.PSP_PAYOUT) {
        this.buildKashioCompanyMenu(app);
      }
    } else if (designVersion === 'V2') {
      this.dataService.designVersion(designVersion);
      if (type === CustomerType.CORPORATE) {
        this.buildKashioCorporateMenuV2(CorporateMenu);
      } else if (type === CustomerType.COMPANY || type === CustomerType.COMPANY_COLLECT || type === CustomerType.COMPANY_PAYOUT || type === CustomerType.PSP_PAYOUT) {
        this.buildKashioCompanyMenuV2(app, CompanyMenu);
      }
    }
  }

  async getKashioGrants(app: string, designVersion: 'V1' | 'V2' = 'V1', type = "") {
    try {
      const data = await this.userService.getAsyncGrants(app, localStorage.getItem('userId'));
      this.tempGrants = data;
      this.companyType = type !== "" ? type : this.tempGrants.company['type'];
      this.grants = this.tempGrants.grants;

      if (this.companyType === CustomerType.CORPORATE) {
        this.buildMenuFromDesign(designVersion, app, this.companyType);
      }
      if (this.companyType === CustomerType.COMPANY || this.companyType === CustomerType.COMPANY_COLLECT || this.companyType === CustomerType.COMPANY_PAYOUT || this.companyType === CustomerType.PSP_PAYOUT) {
        this.buildMenuFromDesign(designVersion, app, this.companyType);
      }
    }
    catch (error) {
      console.error('Failed while trying to get the Grants.' + error)
    }
  }

  async GetConfigCorpMenuDetails() {
    try {
      localStorage.setItem('application', CustomerType.CORPORATE);
      this.getModulesFromAccessJSON(CustomerType.CORPORATE, true, CustomerType.CORPORATE);
      this.getCommonData();
    }
    catch (error) {
      console.error('Failed while trying to get the Grants.' + error)
    }
  }

  async GetAccessConfigDetails() {
    try {
      localStorage.setItem('application', 'PAYMENTS');
      this.getModulesFromAccessJSON('PAYMENTS', true, CustomerType.COMPANY);
      this.getCommonData();
    }
    catch (error) {
      console.error('Failed while trying to get the Grants.' + error)
    }
  }

  getInvoiceAndCustomerLink(type: string, category: string, menuItems: MenuProperties) {
    if (category === 'INVOICES') {
      if (type === 'PAYMENTS') {
        return menuItems.linkPayment;
      } else if (type === 'PAYOUTS') {
        return menuItems.linkPayout;
      } else if (type === 'COLLECT') {
        return menuItems.linkCollect;
      } else {
        return menuItems.link;
      }
    } else if (category === 'CUSTOMERS' || category === 'CONFIGURATION') {
      return menuItems.link;
    } else {
      return null;
    }
  }

  isSubMenuAvailable(category: string, subMenuItem: string) {
    const reports = {
      'SETTLEMENT': 'REPORTS-SETTLEMENTS',
      'PAYMENTS': 'REPORTS-PAYMENTS',
      'NOTIFICATIONS': 'REPORTS-NOTIFICATIONS'
    }

    if (category === 'REPORTS') {
      return this.isKashioSubMenuAvailable(category, subMenuItem) && this.grantsSubMenuAvailable(category, reports[subMenuItem]);
    } else if (category === 'CONFIGURATION') {
      return this.isKashioSubMenuAvailable(category, subMenuItem) && this.grantsSubMenuAvailable('CONFIGURATIONS', subMenuItem);
    } else {
      return false;
    }
  }

  buildSubMenuItem(link: string, iconPath: string, title: string): MenuItemRender {
    return {
      title: title,
      iconPath: iconPath,
      link: link
    };
  }

  buildCorporteSubMenu(category: string, subMenusItems: Record<string, SubMenuProperties>): MenuItemRender[] {
    const subMenu: MenuItemRender[] = [];
    if (category === 'CUSTOMERS' || category === 'INVOICES' || category === 'CONFIGURATION') {
      return subMenu;
    } else {
      for (let subMenuItem in subMenusItems) {
        if (subMenusItems.hasOwnProperty(subMenuItem) && (this.isKashioSubMenuAvailable(category, subMenuItem) && (this.grantsSubMenuAvailable(category, subMenuItem)) || this.isSubMenuAvailable(category, subMenuItem))) {
          subMenu.push(this.buildSubMenuItem(subMenusItems[subMenuItem].link, subMenusItems[subMenuItem].iconPath, subMenusItems[subMenuItem].title));
        }
      }
    }
    return subMenu;
  }

  buildCompanySubMenu(category: string, subMenusItems: Record<string, SubMenuProperties>, app: string = "", customerType: string = ""): MenuItemRender[] {
    const subMenu: MenuItemRender[] = [];
    for (let subMenuItem in subMenusItems) {

      if (subMenusItems.hasOwnProperty(subMenuItem) && ((this.isKashioSubMenuAvailable(category, subMenuItem) && this.grantsSubMenuAvailable(category, subMenuItem)) || this.isSubMenuAvailable(category, subMenuItem))) {

        if (category === 'INVOICES' || category === 'CUSTOMERS' || category === 'CONFIGURATION') {
          return subMenu;
        } else if ((category === 'PAYOUTS' && subMenuItem === 'LIST-COMPANIES' && customerType === 'PSP_PAYOUT') || (category !== 'PAYOUTS' && subMenuItem !== 'LIST-COMPANIES')) {
          subMenu.push(this.buildSubMenuItem(subMenusItems[subMenuItem].link, subMenusItems[subMenuItem].iconPath, subMenusItems[subMenuItem].title));
        }

      }
    }
    return subMenu;
  }

  buildMenuItem(title: string, iconPath: string, subMenus: SubMenuItemRender[], link: string = ""): MenuItemRender {
    let menuItem: MenuItemRender = {
      title: title,
      iconPath: iconPath,
      expanded: false
    };

    if (subMenus.length > 0 && (link === "" || link === null)) {
      menuItem.subMenus = subMenus
    } else if (subMenus.length === 0 && (link !== "" || link !== null)) {
      menuItem.link = link
    }

    return menuItem;
  }

  isMenuAvailable(category: string) {
    if (category === 'CONFIGURATION') {
      return this.isKashioMainMenuAvailable(category) && this.grantsMainMenuAvailable('CONFIGURATIONS');
    } else {
      return false;
    }
  }

  buildMainMenu(category: string, categoryInfo: MenuProperties, menuType: CustomerType.CORPORATE | CustomerType.COMPANY | "" = "", app: string = "", customerType: string = ""): MenuItemRender | null {
    if ((this.isKashioMainMenuAvailable(category) && this.grantsMainMenuAvailable(category)) || this.isMenuAvailable(category)) {
      let subMenu: MenuItemRender[];
      let menuLink: string = "";
      if (menuType === CustomerType.CORPORATE) {
        subMenu = this.buildCorporteSubMenu(category, categoryInfo.subMenus);
        menuLink = categoryInfo.link;
      } else if (menuType === CustomerType.COMPANY) {
        subMenu = this.buildCompanySubMenu(category, categoryInfo.subMenus, app, customerType);
        menuLink = this.getInvoiceAndCustomerLink(app, category, categoryInfo);
      }
      return this.buildMenuItem(categoryInfo.title, categoryInfo.iconPath, subMenu, menuLink);
    }
    return null;
  }

  buildKashioCorporateMenuV2(menu: Menu) {
    if (this.accessModules !== undefined && this.grants !== undefined) {
      const buildMenu: MenuItemRender[] = [];

      for (let category in menu) {
        if (menu.hasOwnProperty(category)) {
          const menuItem = this.buildMainMenu(category, menu[category], CustomerType.CORPORATE);
          if (menuItem) {
            buildMenu.push(menuItem);
          }
        }
      }
      localStorage.setItem('accessmenu', JSON.stringify(buildMenu));
      this.parameterData.AccessMenuValues = buildMenu;
      this.dataService.changeuserprofilephoto(localStorage.getItem('picture'));
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));

      setTimeout(() => {
        this.router.navigate(['/companies']);
      }, 1000)
    } else {
      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 1000)
    }
  }

  buildKashioCompanyMenuV2(app: string, menu: Menu) {
    if (this.accessModules !== undefined && this.grants !== undefined) {
      const buildMenu: MenuItemRender[] = [];

      for (let category in menu) {
        if (menu.hasOwnProperty(category)) {
          const menuItem = this.buildMainMenu(category, menu[category], CustomerType.COMPANY, app, this.customerType);
          if (menuItem) {
            buildMenu.push(menuItem);
          }
        }
      }

      localStorage.setItem('accessmenu', JSON.stringify(buildMenu));
      this.parameterData.AccessMenuValues = buildMenu;
      this.dataService.changeuserprofilephoto(localStorage.getItem('picture'));
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));
      setTimeout(() => {
        this.loginGrantsCheck(app);
      }, 1000)
    }
  }

  buildKashioCorporateMenu() {
    if (this.accessModules !== undefined && this.grants !== undefined) {
      this.buildMenuarray = '';
      if (this.isKashioMainMenuAvailable('MAIN') && this.grantsMainMenuAvailable('MAIN')) {
          this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + " >" +
            "<p href='/companies' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
            "<span class='has-icon'><img src='../../assets/principal-icon.svg'> " + "</span>" +
            "<span class='nav-title'>Principal</span></p>" +
            "<ul aria-expanded='false'>";
          if (this.isKashioSubMenuAvailable('MAIN', 'DASHBOARD') && this.grantsSubMenuAvailable('MAIN', 'DASHBOARD')) {
            this.buildMenuarray = this.buildMenuarray + "<li>" +
              "<a href='/dashboard'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Panel de Control</a>" +
              "</li>";
          }
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/companies'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Empresas</a>" +
            "</li>";
          this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }
      if (this.isKashioMainMenuAvailable('CUSTOMERS') && this.grantsMainMenuAvailable('CUSTOMERS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/clients-icon.svg'> </span>" +
          "<span class='nav-title'>Clientes</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('CUSTOMERS', 'LIST') && this.grantsSubMenuAvailable('CUSTOMERS', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/customers/corporatelist'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('CUSTOMERS', 'CREATE') && this.grantsSubMenuAvailable('CUSTOMERS', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/customers/create'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Crear</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }
      // CORPORATE
      if (this.isKashioMainMenuAvailable('INVOICES') && this.grantsMainMenuAvailable('INVOICES')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/invoices' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/invoice-icon.svg'> </i></span>" +
          "<span class='nav-title'>Ordenes de Pago</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('INVOICES', 'LIST') && this.grantsSubMenuAvailable('INVOICES', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/corporate/invoices'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('INVOICES', 'CREATE') && this.grantsSubMenuAvailable('INVOICES', 'CREATE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/invoices/create'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Crear</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('REPORTS') && this.grantsMainMenuAvailable('REPORTS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/corporate/settlements' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/report-icon.svg'> </span>" +
          "<span class='nav-title'>Reportes</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('REPORTS', 'SETTLEMENT') && this.grantsSubMenuAvailable('REPORTS', 'REPORTS-SETTLEMENTS')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/corporate/settlements'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Liquidaciones</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('REPORTS', 'PAYMENTS') && this.grantsSubMenuAvailable('REPORTS', 'REPORTS-PAYMENTS')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/corporate/payments'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Pagos</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('REPORTS', 'NOTIFICATIONS') && this.grantsSubMenuAvailable('REPORTS', 'REPORTS-NOTIFICATIONS')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/corporate/reports/notificationlist'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Notificaciones</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }
      if (this.isKashioMainMenuAvailable('CONFIGURATION') && this.grantsMainMenuAvailable('CONFIGURATIONS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='settings/profile' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/configuration-icon.svg'></span>" +
          "<span class='nav-title'>Configuración</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('CONFIGURATION', 'PROFILE') && this.grantsSubMenuAvailable('CONFIGURATIONS', 'PROFILE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/settings/profile'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Perfil</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('CONFIGURATION', 'MENU') && this.grantsSubMenuAvailable('CONFIGURATIONS', 'MENU')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='configuration'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>General</a>" +
            "</li>";
        }
        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }
      localStorage.setItem('accessmenu', this.buildMenuarray);
      this.parameterData.AccessMenuValues = this.buildMenuarray;
      this.dataService.changeuserprofilephoto(localStorage.getItem('picture'));
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));

      setTimeout(() => {
        this.router.navigate(['/companies']);
      }, 1000)
    } else {
      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 1000)
    }
  }

  buildKashioCompanyMenu(type: string) {
    if (this.accessModules !== undefined && this.grants !== undefined) {
      this.buildMenuarray = '';

      if (this.isKashioMainMenuAvailable('MAIN') && this.grantsMainMenuAvailable('MAIN')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/dashboard' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'><img src='../../assets/principal-icon.svg'> " + "</span>" +
          "<span class='nav-title'>Principal</span></p>" +
          "<ul aria-expanded='false'>";
        if (this.isKashioSubMenuAvailable('MAIN', 'DASHBOARD') && this.grantsSubMenuAvailable('MAIN', 'DASHBOARD')) {
          this.buildMenuarray = this.buildMenuarray + "<li>" +
            "<a href='/dashboard'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Panel de Control</a>" +
            "</li>";
        }
        if (this.isKashioSubMenuAvailable('MAIN', 'COMPANIES') && this.grantsSubMenuAvailable('MAIN', 'COMPANIES')) {
          if (localStorage.getItem('isCorporate') == 'Yes') {
            this.buildMenuarray = this.buildMenuarray +
              "<li>" +
              "<a href='/companiescallback'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Empresas</a>" +
              "</li>" + "</ul></li>";
          }
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('CUSTOMERS') && this.grantsMainMenuAvailable('CUSTOMERS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/clients-icon.svg'> </span>" +
          "<span class='nav-title'>Clientes</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('CUSTOMERS', 'LIST') && this.grantsSubMenuAvailable('CUSTOMERS', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/customers'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('CUSTOMERS', 'CREATE') && this.grantsSubMenuAvailable('CUSTOMERS', 'CREATE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/customers/create'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Crear</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }
      // COMPANY
      if (this.isKashioMainMenuAvailable('INVOICES') && this.grantsMainMenuAvailable('INVOICES')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/invoices' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/invoice-icon.svg'> </i></span>" +
          "<span class='nav-title'>Ordenes de Pago</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('INVOICES', 'LIST') && this.grantsSubMenuAvailable('INVOICES', 'LIST') && type === 'PAYMENTS') {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/payments/invoices'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        } else if (this.isKashioSubMenuAvailable('INVOICES', 'LIST') && this.grantsSubMenuAvailable('INVOICES', 'LIST') && type === 'PAYOUTS') {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/payout/invoices'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        } else if (this.isKashioSubMenuAvailable('INVOICES', 'LIST') && this.grantsSubMenuAvailable('INVOICES', 'LIST') && type === 'COLLECT') {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/collect/invoices'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('INVOICES', 'CREATE') && this.grantsSubMenuAvailable('INVOICES', 'CREATE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/invoices/create'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Crear</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('SALES') && this.grantsMainMenuAvailable('SALES')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/sales' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/principal-icon.svg'></span>" +
          "<span class='nav-title'>Sales</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('SALES', 'LIST') && this.grantsSubMenuAvailable('SALES', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/sales'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('SALES', 'CREATE') && this.grantsSubMenuAvailable('SALES', 'CREATE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/sales/create'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Crear</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('PAYMENTS') && this.grantsMainMenuAvailable('PAYMENTS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/payments' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<i class='icon-wallet'></i></span>" +
          "<span class='nav-title'>Pagos</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('PAYMENTS', 'LIST') && this.grantsSubMenuAvailable('PAYMENTS', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/payments'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('PAYMENTS', 'CREATE') && this.grantsSubMenuAvailable('PAYMENTS', 'CREATE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/payments/create'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Crear</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('PAYOUTS') && this.grantsMainMenuAvailable('PAYOUTS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/payouts' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<i class='icon-attach_money'></i></span>" +
          "<span class='nav-title'>Pagos Masivos</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('PAYOUTS', 'LIST') && this.grantsSubMenuAvailable('PAYOUTS', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/payout_process/list'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        if ((this.isKashioSubMenuAvailable('PAYOUTS', 'LIST-COMPANIES') && this.grantsSubMenuAvailable('PAYOUTS', 'LIST-COMPANIES')) && this.customerType === 'PSP_PAYOUT') {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/payout_process_commerce/list'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista Comercio</a>" +
            "</li>";
        }
        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('ACCOUNTS') && this.grantsMainMenuAvailable('ACCOUNTS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/accounts' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/account-icon.svg'> </span>" +
          "<span class='nav-title'>Cuentas</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('ACCOUNTS', 'LIST') && this.grantsSubMenuAvailable('ACCOUNTS', 'LIST')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/accounts'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Lista</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('REPORTS') && this.grantsMainMenuAvailable('REPORTS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='/settlements' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/report-icon.svg'> </span>" +
          "<span class='nav-title'>Reportes</span></p>" +
          "<ul aria-expanded='false'>";

        if (this.isKashioSubMenuAvailable('REPORTS', 'SETTLEMENT') && this.grantsSubMenuAvailable('REPORTS', 'REPORTS-SETTLEMENTS')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/settlements'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Liquidaciones</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('REPORTS', 'PAYMENTS') && this.grantsSubMenuAvailable('REPORTS', 'REPORTS-PAYMENTS')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/reports/payments'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Pagos</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('REPORTS', 'NOTIFICATIONS') && this.grantsSubMenuAvailable('REPORTS', 'REPORTS-NOTIFICATIONS')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/reports/notificationlist'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Notificaciones</a>" +
            "</li>";
        }

        this.buildMenuarray = this.buildMenuarray + "</ul></li>";
      }

      if (this.isKashioMainMenuAvailable('CONFIGURATION') && this.grantsMainMenuAvailable('CONFIGURATIONS')) {
        this.buildMenuarray = this.buildMenuarray + "<li routerLinkActive=" + "\"active selected\"" + ">" +
          "<p href='settings/profile' style='cursor:pointer;' class='has-arrow' aria-expanded='false'>" +
          "<span class='has-icon'>" + "<img src='../../assets/configuration-icon.svg'></span>" +
          "<span class='nav-title'>Configuración</span></p>" +
          "<ul aria-expanded='false'>";
        if (this.isKashioSubMenuAvailable('CONFIGURATION', 'PROFILE') && this.grantsSubMenuAvailable('CONFIGURATIONS', 'PROFILE')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='/settings/profile'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>Perfil</a>" +
            "</li>";
        }

        if (this.isKashioSubMenuAvailable('CONFIGURATION', 'MENU') && this.grantsSubMenuAvailable('CONFIGURATIONS', 'MENU')) {
          this.buildMenuarray = this.buildMenuarray +
            "<li>" +
            "<a href='configuration'><span class='has-icon'><img src='../../assets/vector-icon.svg'></span>General</a>" +
            "</li>";
        }
      }

      localStorage.setItem('accessmenu', this.buildMenuarray);
      this.parameterData.AccessMenuValues = this.buildMenuarray;

      this.dataService.changeuserprofilephoto(localStorage.getItem('picture'));
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));
      setTimeout(() => {
        this.loginGrantsCheck(type);
      }, 1000)
    }
  }

  //IF DASHBOARD ISN'T A GRANT FOR MAIN[], CHOOSE THE FIRST OBJECT&GRANT (<> MAIN[]) AS MAIN PAGE. & when KASHIO LOGO is clicked.
  //https://trello.com/c/O7W1uDpX/561-issue-menu-main-page-kashio-logo
  //https://trello.com/c/28KOLdiU/558-issue-menu-main-page-login
  async loginGrantsCheck(type: string) {
    await this.isKashioGrantsAvailable();
    if (this.grantsMainMenuAvailable('MAIN') && this.grantsSubMenuAvailable('MAIN', 'DASHBOARD')) {
      this.router.navigate(['/dashboard']);
    }
    else {
      let grantsKey = Object.keys(this.grants);
      if (grantsKey.length > 0) {
        for (var i = 0; i < grantsKey.length; i++) {
          this.tempMainMenu = grantsKey[i]
          let subMenu = this.grants[this.tempMainMenu];
          if (subMenu.length > 0) {
            this.tempSubMenu = subMenu['0'];
            break;
          }
        }
      }
      if (this.tempMainMenu == 'CONFIGURATIONS') {
        if (this.tempSubMenu == 'PROFILE') {
          this.router.navigate(['/settings/profile']);
        }
        else {
          this.router.navigate(['/configuration']);
        }
      }
      else if (this.tempMainMenu == 'CUSTOMERS') {
        if (this.tempSubMenu == 'CREATE') {
          this.router.navigate(['/customers/create']);
        }
        else {
          this.router.navigate(['/customers']);
        }
      }
      else if (this.tempMainMenu == 'INVOICES') {
        if (this.tempSubMenu == 'CREATE') {
          this.router.navigate(['/invoices/create']);
        }
        else if (this.tempSubMenu !== 'CREATE' && type === 'PAYOUTS') {
          this.router.navigate(['/payout/invoices']);
        } else if (this.tempSubMenu !== 'CREATE' && type === 'PAYMENTS') {
          this.router.navigate(['/payments/invoices']);
        } else if (this.tempSubMenu !== 'CREATE' && type === 'COLLECT') {
          this.router.navigate(['/collect/invoices']);
        }
      }
      else if (this.tempMainMenu == 'ACCOUNTS') {
        this.router.navigate(['/accounts']);
      }
      else if (this.tempMainMenu == 'PAYOUTS') {
        this.router.navigate(['/payout_process/list']);
      }
      else if (this.tempMainMenu == 'PAYMENTS') {
        if (this.tempSubMenu == 'CREATE') {
          this.router.navigate(['/payments/create']);
        }
        else {
          this.router.navigate(['/payments']);
        }
      }

      else if (this.tempMainMenu == 'REPORTS') {
        if (this.tempSubMenu == 'REPORTS-SETTLEMENTS') {
          this.router.navigate(['/settlements']);
        }
        if (this.tempSubMenu == 'REPORTS-PAYMENTS') {
          this.router.navigate(['/reports/payments']);
        }
        if (this.tempSubMenu == 'REPORTS-NOTIFICATIONS') {
          this.router.navigate(['/reports/notificationlist']);
        }
      }

      else if (this.tempMainMenu == 'SALES') {
        if (this.tempSubMenu == 'CREATE') {
          this.router.navigate(['/sales/create']);
        }
        else {
          this.router.navigate(['/sales']);
        }
      }
    }
  }

  isKashioMainMenuAvailable(menuName) {
    if (this.accessModules[menuName] != null || this.accessModules[menuName] != undefined) {
      return true;
    } else {
      return false;
    }
  }

  isKashioSubMenuAvailable(mainMenu, subMenu) {
    if (this.accessModules[mainMenu] != null || this.accessModules[mainMenu] != undefined) {
      let menuList = this.accessModules[mainMenu];
      const strArray = menuList;
      if (strArray.includes(subMenu)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  grantsMainMenuAvailable(menuName) {
    if (this.grants[menuName] != null || this.grants[menuName] != undefined) {
      return true;
    }
    else {
      return false;
    }
  }

  grantsSubMenuAvailable(mainMenu, subMenu) {
    if (this.grants[mainMenu] != null || this.grants[mainMenu] != undefined) {
      let menuList = this.grants[mainMenu];
      const strArray = menuList;
      if (strArray.includes(subMenu)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public getAllAccessDetails(): Observable<any> {
    const jsonFile = 'assets/config/access.json?v=' + moment(new Date()).format('YYYYMMDDHHmm');
    return this.http.get(jsonFile)
      .pipe(map(res => res)
      );
  }

  public getProfile(cb): void {

    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('Access token must exist to fetch profile');
    }

    const self = this;
    this.auth0.client.userInfo(accessToken, (err, profile) => {
      if (profile) {
        self.userProfile = profile;
        localStorage.setItem('auth0profile', JSON.stringify(profile));
      }
      cb(err, profile);
    });
  }

}
